import { createAction } from 'redux-act';

export type { CouponDealFormPayload } from '#app/pages/Relations/CouponDeal/types/couponDealForm';
import type { CouponDealFormPayload } from '#app/pages/Relations/CouponDeal/types/couponDealForm';

export const setCouponDealModalVisible = createAction<boolean>('SET_COUPON_DEAL_MODAL_VISIBLE');
export const setCouponDealForm = createAction<CouponDealFormPayload>('SET_COUPON_DEAL_FORM');
export const closeCouponDealForm = createAction('CLOSE_COUPON_DEAL_FORM');
